import "antd/dist/antd.css";
import { Layout } from "antd";
import Colors from "assets/Colors";
import useWindowSize from "useWindowSize";
import Constants from "helpers/constants";
import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Footer from "components/common/Footer";
import SiderSecondary from "../containers/SideBarTopMenuHOC/SiderSecondary";
import CustomSider from "../containers/SideBarTopMenuHOC/Sider";
import BottomDrawer from "../containers/SideBarTopMenuHOC/BottomDrawer";
import CustomHeader from "../containers/SideBarTopMenuHOC/Header";

const { Header, Content } = Layout;

function SecuredContainer() {
  const size = useWindowSize();
  const [openSideBar, setOpenSideBar] = useState(true);

  const location = useLocation();
  const path = location.pathname;
  const showingSecondarySider =
    path.includes("/config/") ||
    path.includes("/reports/") ||
    path.includes("/employees/") ||
    path.includes("/operations/") ||
    path.includes("/reservations/") ||
    path.includes("/settings/") ||
    path.includes("/inventory/");

  const noShowBottomDrawer = size.width > Constants.pxMobileBreakPoint;

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Header
          style={{
            background: "white",
            paddingLeft: "20px",
            paddingRight: "53px",
            borderBottom: `1px solid ${Colors.line_separator}`,
          }}
        >
          <CustomHeader
            showingSecondarySider={showingSecondarySider}
            setOpenSideBar={() => setOpenSideBar(!openSideBar)}
            showThingsHeader={noShowBottomDrawer}
          />
        </Header>
        <Layout>
          {noShowBottomDrawer && (
            <CustomSider
              showingSecondarySider={showingSecondarySider}
              openSideBar={openSideBar}
              setOpenSideBar={setOpenSideBar}
            />
          )}
          {showingSecondarySider && noShowBottomDrawer && <SiderSecondary />}

          <Layout style={{ background: Colors.background_secondary }}>
            <Content
              style={{
                padding: 24,
                paddingTop: "19px",
                margin: 0,
                minHeight: 280,
              }}
            >
              <BottomDrawer
                noShowBottomDrawer={noShowBottomDrawer}
                component={<Outlet />}
              />
            </Content>
          </Layout>
        </Layout>
      </Layout>
      <Footer paddingBottom="50px" />
    </>
  );
}

export default SecuredContainer;
